import Component from '../Component';

class FilterNav extends Component {
  constructor(options) {
    super(options);

    this.navState = {
      isOpen: false
    };

    this.trigger = this.root.querySelector('.mobile_trigger');
    this.nav = this.root.querySelector('.nav_container');
    this.dropdown = this.root.querySelectorAll('.filter_group');
  }

  showNavigation() {
    this.navState.isOpen = true;
    this.nav.classList.add('nav_open');
  }

  hideNavigation() {
    this.navState.isOpen = false;
    this.nav.classList.remove('nav_open');
  }

  toggleNavigation() {
    if (this.navState.isOpen) {
      this.hideNavigation();
    } else {
      this.showNavigation();
    }
  }

  attachEventListeners() {
    this.trigger.addEventListener('click', () => {
      this.toggleNavigation();
    });

    this.dropdown.forEach((dropdown) => {
      const trigger = dropdown.querySelector('.dropdown_trigger');
      const dropdownState = {
        isOpen: false
      };

      function openDropdown() {
        dropdownState.isOpen = true;
        dropdown.classList.add('dropdown_open');
      }

      function closeDropdown() {
        dropdownState.isOpen = false;
        dropdown.classList.remove('dropdown_open');
      }

      function toggleDropdown() {
        if (dropdownState.isOpen) {
          closeDropdown();
        } else {
          openDropdown();
        }
      }

      trigger.addEventListener('click', () => {
        toggleDropdown();
      });
    });
  }

  componentDidMount() {
    this.attachEventListeners();
  }
}

export default FilterNav;
